<template>
  <div>
    <social-header v-if="currentEnv" title="可提现"></social-header>
    <div class="withdraw" v-if="payMoneyList.length > 0">
      <ul class="withdraw-list">
        <li
          class="withdraw-list-item"
          v-for="(item, index) in payMoneyList"
          :key="index"
        >
          <div class="activity-name">
            <div class="left">活动</div>
            <div class="right">{{ item.activityName }}</div>
          </div>
          <div class="order-no">
            <div class="left">订单号</div>
            <div class="right">{{ item.orderId }}</div>
          </div>
          <div class="order-no">
            <div class="left">业务订单号</div>
            <div class="right">{{ item.businessOrderId }}</div>
          </div>
          <!-- <div class="order-no">
            <div class="left">平台编号</div>
            <div class="right">{{item.orderId}}</div>
          </div> -->
          <div class="withdraw-price">
            <div class="left">可提现金额</div>
            <div class="right">￥{{ item.price }}</div>
          </div>
          <div class="award-state">
            <div class="left">奖励节点</div>
            <div v-if="item.nodeId == '700' || item.nodeId == '800'">
              审批通过
            </div>
            <div v-else class="right">{{ item.nodeName }}</div>
          </div>
          <div class="award-type">
            <div class="left">奖励类型</div>
            <div class="right">{{ item.settlementType }}</div>
          </div>
          <div class="award-type" v-if="item.agentName">
            <div class="left">代理人姓名</div>
            <div class="right">{{ item.agentName }}</div>
          </div>
          <div class="award-time">
            <div class="left">奖励时间</div>
            <div class="right">{{ item.dateStr }}</div>
          </div>
        </li>
      </ul>
    </div>
    <Empty v-else />
    <WithdrawButton :disabled="isWithdraw" />
    <social-dialog
      title="正在加载"
      category="tips"
      v-bind:show="dialogShow"
    ></social-dialog>
    <pull-load
      target-element="withdraw-list"
      v-bind:bottom-method="loadMorePayMoney"
      v-bind:state="loadMoreState"
    ></pull-load>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Empty from "../../components/empty.vue";
import WithdrawButton from "../../components/withdraw-button.vue";
import SocialHeader from "../../components/social-header.vue";
import {
  isWeiXin,
  isDingDing,
  changeDocumentTitle,
} from "../../service/environment";
import SocialDialog from "../../components/social-dialog.vue";
import PullLoad from "../../components/pull-load.vue";
export default {
  name: "Withdraw",
  components: {
    Empty,
    WithdrawButton,
    SocialHeader,
    SocialDialog,
    PullLoad,
  },
  data: function () {
    return {
      dialogShow: false,
      loadMoreState: 0,
    };
  },
  computed: {
    ...mapGetters({
      payMoneyList: "payMoneyList",
    }),
    currentEnv() {
      if (isWeiXin()) {
        return false;
      } else if (isDingDing()) {
        return false;
      } else {
        return true;
      }
    },
    userINFO() {
      return JSON.parse(localStorage.getItem("USER_INFO"));
    },
    isWithdraw() {
      if (this.payMoneyList.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    loadMorePayMoney: function () {
      var current = this;
      current.dialogShow = true;
      if (this.loadMoreState !== 0) {
        return false;
      }
      this.loadMoreState = 1;
      this.$store
        .dispatch("loadMorePayMoney", {
          PlatformAgentID: current.userINFO.platformAgentID,
          dataType: 10,
        })
        .then(function () {
          current.loadMoreState = 0;
          if (current.$store.getters.isPayMoneyPageEnd) {
            current.loadMoreState = 2;
          }
          current.dialogShow = false;
        });
    },
  },
  created() {
    var current = this;
    changeDocumentTitle("可提现");
    current.dialogShow = true;
    this.$store
      .dispatch("getPayMoney", {
        PlatformAgentID: current.userINFO.platformAgentID,
        dataType: 10,
      })
      .then(function () {
        current.dialogShow = false;
      });
  },
};
</script>
<style scoped>
.withdraw {
  width: 100%;
  min-height: 100%;
  height: auto;
  position: relative;
}
.withdraw-list {
  width: 100%;
  padding: 1.25rem 0.875rem;
  box-sizing: border-box;
  overflow: auto;
  padding-bottom: 5rem;
}
.withdraw-list-item {
  width: 100%;
  margin-bottom: 0.75rem;
  padding: 1.25rem 1.0625rem;
  background-color: #fff;
  border-radius: 0.75rem;
  box-sizing: border-box;
}
.withdraw-list-item .activity-name,
.order-no,
.withdraw-price,
.award-state,
.award-type,
.award-time {
  display: flex;
  font-size: 0.875rem;
  height: 1.875rem;
  align-items: center;
  color: #777;
}
.withdraw-list-item .activity-name .left,
.withdraw-list-item .order-no .left,
.withdraw-list-item .withdraw-price .left,
.withdraw-list-item .award-state .left,
.withdraw-list-item .award-type .left,
.withdraw-list-item .award-time .left {
  color: rgb(17, 30, 54);
  width: 7.5rem;
  flex-shrink: 0;
}
.withdraw-list-item .activity-name .right,
.withdraw-list-item .order-no .right,
.withdraw-list-item .withdraw-price .right,
.withdraw-list-item .award-state .right,
.withdraw-list-item .award-type .right,
.withdraw-list-item .award-time .right {
  width: 100%;
  text-align: right;
}
.withdraw-list-item .withdraw-price .right {
  color: rgb(45, 117, 255);
}
</style>



// WEBPACK FOOTER //
// src/pages/account/withdraw.vue